import { api } from "../../../utility/apiClient";

/**
 * GET /api/v1/notifications
 * @param {{ page?: number, limit?: number, unread?: boolean }} params
 * @returns {{ success, data: { notifications: [], unread_count: number }, meta }}
 */
export const getNotifications = ({ page = 1, limit = 20, unread } = {}) => {
  const qs = new URLSearchParams({ page, limit });
  if (unread) qs.set("unread", "true");
  return api.get(`/api/v1/notifications?${qs.toString()}`);
};

/** GET /api/v1/notifications/unread-count → { data: { unread_count } } */
export const getUnreadCount = () => api.get("/api/v1/notifications/unread-count");

/** PATCH /api/v1/notifications/:id/read */
export const markNotificationRead = (id) => api.patch(`/api/v1/notifications/${id}/read`);

/** PATCH /api/v1/notifications/read-all */
export const markAllNotificationsRead = () => api.patch("/api/v1/notifications/read-all");
